export const MAX_POSITION_SHOWS = 6;
export const MIN_POSITION_SHOWS = 0;
